export { initSession } from 'next-flight-server-reference-proxy-loader?id=7fc0cab6de2a5701efde86c10854d162ffd1104475&name=initSession!'